"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTable = DataTable;
var React = _interopRequireWildcard(require("react"));
var _reactTable = require("react-table");
var _semanticUiReact = require("semantic-ui-react");
var _SpreadsheetExport = require("../utils/SpreadsheetExport");
var _Media = require("../utils/Media");
var _excluded = ["filterValue", "preFilteredRows", "setFilter"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
//import "../../styles/Datatables.css";

function DefaultColumnFilter(_ref) {
  var _ref$column = _ref.column,
    filterValue = _ref$column.filterValue,
    preFilteredRows = _ref$column.preFilteredRows,
    setFilter = _ref$column.setFilter,
    col = _objectWithoutProperties(_ref$column, _excluded),
    readOnlyFilter = _ref.readOnlyFilter;
  var count = preFilteredRows.length;
  return /*#__PURE__*/React.createElement(_semanticUiReact.Input, {
    value: filterValue || "",
    icon: !filterValue && "search",
    fluid: true,
    disabled: readOnlyFilter,
    onChange: function onChange(e) {
      setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
    },
    placeholder: "Search ".concat(col.Header),
    className: filterValue && "with-value",
    title: filterValue,
    focus: filterValue
  });
}
var getTableData = function getTableData(rows, columns) {
  var usedColumns = columns.filter(function (f) {
    return f.noExport === undefined;
  });
  var dataColumns = usedColumns.map(function (c) {
    return {
      header: c.Header,
      type: /*c.exportType ||*/c.fixedNumber ? _SpreadsheetExport.CellDataType.NUMBER : _SpreadsheetExport.CellDataType.ANY
    };
  });
  var dataRows = rows.map(function (row) {
    var dataRow = [];
    usedColumns.forEach(function (c) {
      var value = row.values[c.id];
      if (c.exportAccessor) {
        value = c.exportAccessor(row.original);
      }
      if (typeof value == "string") {
        if (value == "-") {
          value = 0;
        } else {
          value = value.replace("�", "-");
        }
        dataRow.push(value);
      } else if (typeof value == "number") {
        if (c.fixedNumber) {
          value = value.toFixed(c.fixedNumber);
          value = value.replace(".", ",");
        } else if (value == 0) {
          value = c.fixedNumber ? "0,00" : "0";
        } else {
          value = value.toString();
        }
        dataRow.push(value);
      } else {
        if (c.fixedNumber) {
          value = 0.0;
          value = value.toFixed(c.fixedNumber);
          value = value.replace(".", ",");
          dataRow.push(value);
        } else {
          dataRow.push(value ? value.toString() : c.fixedNumber ? "0,00" : "");
        }
      }
    });
    return dataRow;
  });
  return {
    columns: dataColumns,
    rows: dataRows
  };
};
function DataTable(props) {
  var filterTypes = React.useMemo(function () {
    return {
      // Add a new fuzzyTextFilterFn filter type.
      // Or, override the default text filter to use
      // "startWith"
      text: function text(rows, id, filterValue) {
        return rows.filter(function (row) {
          var rowValue = row.values[id];
          return rowValue ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()) : true;
        });
      }
    };
  }, []);
  var defaultColumn = React.useMemo(function () {
    return {
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    };
  }, []);
  // Use the state and functions returned from useTable to build your UI
  var _useTable = (0, _reactTable.useTable)({
      columns: props.columns,
      data: props.data,
      defaultColumn: defaultColumn,
      filterTypes: filterTypes,
      autoResetFilters: props.autoResetFilters,
      autoResetPage: props.autoResetPage,
      readOnlyFilter: props.readOnlyFilter,
      downloadButtonBottom: props.downloadButtonBottom,
      downloadDialog: props.downloadDialog
    }, _reactTable.useFilters, _reactTable.useSortBy, _reactTable.usePagination),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    prepareRow = _useTable.prepareRow,
    page = _useTable.page,
    preSortedRows = _useTable.preSortedRows,
    columns = _useTable.columns,
    canPreviousPage = _useTable.canPreviousPage,
    canNextPage = _useTable.canNextPage,
    pageOptions = _useTable.pageOptions,
    pageCount = _useTable.pageCount,
    gotoPage = _useTable.gotoPage,
    nextPage = _useTable.nextPage,
    previousPage = _useTable.previousPage,
    setPageSize = _useTable.setPageSize,
    _useTable$state = _useTable.state,
    pageIndex = _useTable$state.pageIndex,
    pageSize = _useTable$state.pageSize;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    Open = _React$useState2[0],
    SetOpen = _React$useState2[1];
  var exportCSV = React.useCallback(function () {
    var data = getTableData(preSortedRows, columns);
    data && props.exportFileName && (0, _SpreadsheetExport.saveSpreadsheetCSV)(props.exportFileName, data);
  }, [preSortedRows, columns]);
  var firstPageRows = page;
  var results = props.data.length; // to show count of all results found
  if (props.paging && pageSize != props.paging && props.paging >= 1) {
    if (props.paging === 1000 && pageSize !== results) {
      setPageSize(results);
    } else {
      setPageSize(props.paging);
    }
  }
  var count = pageCount * pageSize;
  var scrollStyle = {
    overflowX: "scroll"
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !props.downloadButtonBottom && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      width: "100%",
      marginTop: "5px"
    }
  }, props.header, props.exportFileName && /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
    className: "datatableButtons",
    secondary: true,
    style: props.buttonStyle,
    floated: "right",
    content: "Download",
    icon: "cloud download",
    onClick: function onClick() {
      return props.downloadDialog != undefined ? SetOpen(true) : exportCSV();
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: props.scrollHorizontal ? scrollStyle : undefined
  }, /*#__PURE__*/React.createElement(_semanticUiReact.Table, _extends({
    className: "data-table",
    sortable: true,
    celled: true,
    fixed: !props.scrollHorizontal
  }, getTableProps()), /*#__PURE__*/React.createElement(_semanticUiReact.Table.Header, null, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: headerGroup.getHeaderGroupProps().key
    }, /*#__PURE__*/React.createElement(_Media.Media, {
      greaterThanOrEqual: "computer"
    }, function (className, renderChildren) {
      return renderChildren && /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
        return (
          /*#__PURE__*/
          // Add the sorting props to control sorting. For this example
          // we can add them into the header props
          React.createElement(_semanticUiReact.Table.HeaderCell, _extends({
            sorted: column.isSorted ? column.isSortedDesc ? "descending" : "ascending" : undefined
          }, column.getHeaderProps([column.getSortByToggleProps(), {
            className: column.className,
            style: column.style
          }])), column.render("Header"))
        );
      }));
    }), props.data && props.data.length > 0 && headerGroup.headers.some(function (c) {
      return c.canFilter;
    }) && /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, _extends({}, headerGroup.getHeaderGroupProps(), {
      key: "header1"
    }), headerGroup.headers.map(function (column) {
      return (
        /*#__PURE__*/
        // Add the sorting props to control sorting. For this example
        // we can add them into the header props
        React.createElement(_semanticUiReact.Table.HeaderCell, column.getHeaderProps([{
          className: column.className,
          style: column.style
        }]), column.canFilter ? column.render("Filter") : null)
      );
    })));
  })), /*#__PURE__*/React.createElement(_semanticUiReact.Table.Body, getTableBodyProps(), props.loading ? /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Cell, {
    colSpan: columns.length
  }, /*#__PURE__*/React.createElement(_semanticUiReact.Segment, {
    style: {
      margin: "2em"
    },
    basic: true,
    loading: true
  }))) : firstPageRows.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, row.getRowProps(), row.cells.map(function (cell) {
      return /*#__PURE__*/React.createElement(_semanticUiReact.Table.Cell, cell.getCellProps([{
        className: cell.column.className,
        style: cell.column.style
      }]), cell.render("Cell"));
    }));
  }))), count > pageSize && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hide-print"
  }, /*#__PURE__*/React.createElement(_semanticUiReact.Pagination, {
    onPageChange: function onPageChange(e, _ref2) {
      var activePage = _ref2.activePage;
      return gotoPage(Number(activePage) - 1);
    },
    boundaryRange: 0,
    ellipsisItem: null,
    siblingRange: 1,
    activePage: pageIndex + 1,
    totalPages: pageCount
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", null, "Showing", " ", pageIndex + 1 === pageCount ? results - pageSize : pageSize, " ", "results out of ", results))), /*#__PURE__*/React.createElement(_semanticUiReact.Confirm, {
    open: Open,
    header: "Beware before downloading!",
    content: "".concat(props.downloadDialog),
    onCancel: function onCancel() {
      return SetOpen(false);
    },
    onConfirm: function onConfirm() {
      SetOpen(false);
      exportCSV();
    }
  }), props.downloadButtonBottom && /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: "10px"
    }
  }, props.header, props.exportFileName && /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
    className: "mb-5 datatableButtons",
    secondary: true,
    style: props.buttonStyle,
    floated: "right",
    content: "Download",
    icon: "cloud download",
    onClick: function onClick() {
      return props.downloadDialog != undefined ? SetOpen(true) : exportCSV();
    }
  })));
}